import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { MessageSquare, X, Send } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { useAuth } from "@/hooks/useAuth";

export default function FeedbackWidget() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const { toast } = useToast();
  const { user } = useAuth();

  const handleSubmit = async () => {
    if (!message.trim()) return;
    setSending(true);
    const { error } = await supabase.from("feedback").insert({
      user_id: user?.id || null,
      message: message.trim(),
      page_url: window.location.pathname,
    } as any);
    setSending(false);
    if (error) {
      toast({ title: "Fehler", description: "Feedback konnte nicht gesendet werden.", variant: "destructive" });
    } else {
      toast({ title: "Danke!", description: "Dein Feedback wurde gesendet." });
      setMessage("");
      setOpen(false);
    }
  };

  return (
    <>
      {/* Floating button */}
      <button
        onClick={() => setOpen(!open)}
        className="fixed bottom-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg hover:bg-primary/90 transition-colors"
        aria-label="Feedback geben"
      >
        {open ? <X size={20} /> : <MessageSquare size={20} />}
      </button>

      {/* Feedback panel */}
      {open && (
        <div className="fixed bottom-20 right-6 z-50 w-80 rounded-lg border border-border bg-background p-5 shadow-xl">
          <h3 className="font-display text-lg font-bold uppercase tracking-tight">Feedback</h3>
          <p className="mt-1 text-sm text-muted-foreground">Was können wir verbessern?</p>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Dein Feedback..."
            rows={4}
            className="mt-3 w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring resize-none"
          />
          <Button
            onClick={handleSubmit}
            disabled={!message.trim() || sending}
            className="mt-3 w-full"
            size="sm"
          >
            <Send size={14} />
            {sending ? "Wird gesendet..." : "Absenden"}
          </Button>
        </div>
      )}
    </>
  );
}
